var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"text-align":"center"},attrs:{"fluid":""}},[_c('canvas',{attrs:{"id":"myChart","width":"400","height":"400"}})])}
var staticRenderFns = []

export { render, staticRenderFns }